var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12870",
    "data-name": "Group 12870",
    transform: "translate(-773 -2475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(773 2475)",
    fill: "#f4ea5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail_1_",
    "data-name": "mail (1)",
    transform: "translate(785.723 2405.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(24.611 90.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M345.063,105.876,331.709,117l13.377,8.9V106.127A1.5,1.5,0,0,0,345.063,105.876Z",
    transform: "translate(-331.709 -105.876)",
    fill: "#143727"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 102.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M23.407,269.264l-1.683,1.4a4.265,4.265,0,0,1-5.459,0l-1.683-1.4L0,278.968v.2a1.5,1.5,0,0,0,1.5,1.5H36.485a1.5,1.5,0,0,0,1.5-1.5v-.2Z",
    transform: "translate(0 -269.264)",
    fill: "#143727"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(1.272 89.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M52.366,89.012H17.371a.23.23,0,0,0-.141.407l13.747,11.447,0,0,2.118,1.764a2.764,2.764,0,0,0,3.537,0l15.87-13.215A.23.23,0,0,0,52.366,89.012Z",
    transform: "translate(-17.147 -89.012)",
    fill: "#143727"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(0 90.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M.023,105.876a1.5,1.5,0,0,0-.023.251V125.9L13.377,117Z",
    transform: "translate(0 -105.876)",
    fill: "#143727"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.140add3c29dc65f90bf1fd03d1d05a6c.svg";
export { ForwardRef as ReactComponent };